import { request } from 'utils/requests'

// O que está ligado no servidor, buscado uma vez por sessão. O Escavador (pago)
// fica desligado; as telas que dependem dele se escondem.
let integracoesPromise = null
export const getIntegracoes = () => {
  if (!integracoesPromise) {
    integracoesPromise = request.get('/integracoes')
      .then(({ data }) => ({ escavadorAtivo: Boolean(data?.escavadorAtivo) }))
      .catch(() => { integracoesPromise = null; return { escavadorAtivo: false } })
  }
  return integracoesPromise
}

// Rodada extra do robô (admin): agora ou num horário, uma vez
export const listarRodadasExtras = async () => (await request.get('/integracoes/robo/extra')).data
export const agendarRodadaExtra = async (quando) => (await request.post('/integracoes/robo/extra', quando ? { quando } : {})).data
export const diagnosticoRobo = async (testarFontes = false) => (await request.get('/integracoes/robo/diagnostico', { params: testarFontes ? { fontes: 1 } : {} })).data
